module.exports = __webpack_public_path__ + "img/ics1016-min.26a30c65.jpg";